export enum UdpTestType {
    DOWNLAOD = "udp_rx",
    UPLOAD = "udp_tx"
};